import * as Sentry from "@sentry/react";
import {BrowserTracing} from "@sentry/tracing";

const configSentry = () => {
    let UNIQUE_CLIENT_ID, REQUEST_ID, USER_IP
    let arrayb = document?.cookie?.split(";");
    // console.log("---  Cookies  ---");
    for (let item of arrayb) {
        const [keyCookie, value] = item.trim().split("=")
        // console.log({keyCookie, value});
        if (keyCookie.trim().startsWith("unique_client_id")) UNIQUE_CLIENT_ID = value
        if (keyCookie.trim().startsWith("request-id")) REQUEST_ID = value
        if (keyCookie.trim().startsWith("user-ip")) USER_IP = value
    }
    
    // console.log("process.env.SENTRY_DNS_FRONTEND = '" + process.env.SENTRY_DNS_FRONTEND + "'");
    Sentry.init({
        dsn: process.env.SENTRY_DNS_FRONTEND,
        debug: false,
        environment: (process.env.NODE_ENV === 'production' && process.env.DEV_ENV === 'PRO') ? "production" : "development",
        ip: true,
        integrations: [
            new BrowserTracing(),
            new Sentry.Replay({
                // Additional SDK configuration goes in here, for example:
                maskAllText: false, //default: true
                blockAllMedia: false, //default: true
                maskAllInputs: false, //default: true
            })],
        // replaysSessionSampleRate: 0.1,
        replaysSessionSampleRate: (process.env.NODE_ENV === 'production' && process.env.DEV_ENV === 'PRO') ? 0.1 : 1.0,
        
        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: 1.0,
        
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: (process.env.NODE_ENV === 'production' && process.env.DEV_ENV === 'PRO') ? 0.3 : 1.0,
        
        // initialScope: {
        // tags: {
        //     unique_client_id : UNIQUE_CLIENT_ID
        // },
        // user: {ip: USER_IP, email: "john.doe1@example.com", unique_client_id: UNIQUE_CLIENT_ID},
        // },
    });
    Sentry.setUser({ip: USER_IP, /*email: "john.doe2@example.com",*/ unique_client_id: UNIQUE_CLIENT_ID});
    
    Sentry.configureScope(scope => {
        scope.setContext("Request", {
            unique_client_id: UNIQUE_CLIENT_ID,
            request_id: REQUEST_ID,
            user_ip: USER_IP,
        });
    });
    
};


export default configSentry;